import type { IconName } from '@ministries/storybook'

export interface AppNavItem {
  icon: IconName
  id:
    | 'admin'
    | 'coffee'
    | 'events'
    | 'features'
    | 'home'
    | 'music'
    | 'notifications'
    | 'profile'
  label: string
  route:
    | '/'
    | '/admin'
    | '/coffee'
    | '/events'
    | '/features'
    | '/music'
    | '/notifications'
    | '/profile'
  section?: '#home'
}

interface AppNavLabels {
  admin: string
  coffee: string
  events: string
  features: string
  home: string
  music: string
  notifications: string
  profile: string
}

export function getAppNavItems(
  labels: AppNavLabels,
  options: { isAdmin: boolean }
): AppNavItem[] {
  const adminItems: AppNavItem[] = options.isAdmin
    ? [
        {
          icon: 'users',
          id: 'admin',
          label: labels.admin,
          route: '/admin'
        }
      ]
    : []

  return [
    {
      icon: 'home',
      id: 'home',
      label: labels.home,
      route: '/',
      section: '#home'
    },
    {
      icon: 'calendar',
      id: 'events',
      label: labels.events,
      route: '/events'
    },
    {
      icon: 'users',
      id: 'features',
      label: labels.features,
      route: '/features'
    },
    {
      icon: 'clock',
      id: 'notifications',
      label: labels.notifications,
      route: '/notifications'
    },
    {
      icon: 'calendar',
      id: 'music',
      label: labels.music,
      route: '/music'
    },
    ...adminItems,
    {
      icon: 'calendar',
      id: 'coffee',
      label: labels.coffee,
      route: '/coffee'
    },
    {
      icon: 'users',
      id: 'profile',
      label: labels.profile,
      route: '/profile'
    }
  ]
}

export function getAppNavTarget(item: AppNavItem): AppNavItem['route'] {
  return item.route
}

export function isAppNavItemActive(
  item: AppNavItem,
  pathname: string,
  hash: string
): boolean {
  if (item.route !== '/') {
    return pathname === item.route || pathname.startsWith(`${item.route}/`)
  }

  if (pathname !== '/') {
    return false
  }

  if (item.section === '#home') {
    return hash === '' || hash === '#home'
  }

  return hash === item.section
}
